import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewPageBannerComponent } from '@mode/shared/ui';
import { formatInTimeZone } from 'date-fns-tz';

@Component({
  selector: 'mode-purged-run-banner',
  templateUrl: './purged-report-banner.component.html',
  styleUrl: './purged-report-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ViewPageBannerComponent],
})
export class PurgedReportBannerComponent {
  @Input() viewingLatestRun = false;
  @Input() moreRecentRunAvailable = false;
  @Input() latestDataUrl: string | null = null;
  @Input() historicRunDate: Date | string | null = null;
  @Output() refreshReport = new EventEmitter<void>();

  get formattedHistoricRunDate(): string {
    if (!this.historicRunDate) return '';

    return formatInTimeZone(this.historicRunDate, 'UTC', "MMM d, yyyy 'at' h:mm a 'UTC'");
  }
}
